<ion-header>
  <ion-toolbar>
    <ion-title>End User License Agreement</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="eula-container">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-container">
      <ion-spinner name="crescent"></ion-spinner>
      <p>Loading EULA content...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorMessage && !isLoading" class="error-container">
      <ion-text color="danger">
        <p>{{ errorMessage }}</p>
      </ion-text>
      <ion-button fill="outline" (click)="loadEULAContent()">
        Retry
      </ion-button>
    </div>

    <!-- EULA Content -->
    <div *ngIf="!isLoading && !errorMessage" class="eula-content">
      <div class="eula-text" [innerHTML]="eulaContent"></div>
      
      <div class="eula-actions">
        <ion-item lines="none" class="checkbox-item">
          <ion-checkbox 
            [(ngModel)]="hasAcceptedCheckbox"
            (ionChange)="onCheckboxChange($event)"
            slot="start">
          </ion-checkbox>
          <ion-label class="checkbox-label">
            I have read and ACCEPT the Terms of Service
          </ion-label>
        </ion-item>

        <div *ngIf="errorMessage" class="error-message">
          <ion-text color="danger">
            <p>{{ errorMessage }}</p>
          </ion-text>
        </div>

        <div class="button-container">
          <ion-button 
            fill="outline" 
            (click)="declineEULA()"
            [disabled]="isAccepting">
            Decline
          </ion-button>
          
          <ion-button 
            (click)="acceptEULA()"
            [disabled]="!hasAcceptedCheckbox || isAccepting">
            <ion-spinner name="dots" *ngIf="isAccepting"></ion-spinner>
            <span>{{ isAccepting ? 'Accepting...' : 'Accept' }}</span>
          </ion-button>
        </div>
      </div>
    </div>
  </div>
</ion-content> 